'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatMessage = function ChatMessage(_ref) {
    var chatteeId = _ref.chatteeId,
        senderId = _ref.senderId,
        user = _ref.user,
        text = _ref.text,
        delivery_status = _ref.delivery_status,
        time = _ref.time,
        user_pic = _ref.user_pic,
        mask_user_typing_text = _ref.mask_user_typing_text;

    var containerType = chatteeId === senderId ? "row msg_container base_sent" : "row msg_container base_receive";
    var padding = chatteeId === senderId ? "col-md-10 col-xs-10 no-padding" : "col-md-10 col-xs-10 no-padding";
    var messageType = chatteeId === senderId ? "messages msg_sent" : "messages msg_receive";
    var messageDelivered = delivery_status === 'delivered' ? 'fa fa-check' : '';
    var sender_Name = void 0;
    var received_Name = void 0;
    if (mask_user_typing_text) {
        sender_Name = Constants.DEFAULT_SELF_NAME;
        received_Name = mask_user_typing_text ? Constants.DEFAULT_AGENT_NAME : Constants.DEFAULT_GUEST_NAME;
    } else {
        // sender_Name = user.name ? user.name : "Agent"
        sender_Name = Constants.DEFAULT_SELF_NAME;
        received_Name = user.name ? user.name : "guest";
    }
    var profilePic = user.pic;

    if (chatteeId === senderId) {
        return _react2.default.createElement(
            'div',
            { className: containerType },
            _react2.default.createElement(
                'div',
                { className: padding },
                _react2.default.createElement(
                    'div',
                    { className: messageType },
                    _react2.default.createElement(
                        'p',
                        { className: 'message' },
                        text
                    ),
                    _react2.default.createElement(
                        'time',
                        null,
                        sender_Name,
                        ' \u2022 ',
                        (0, _moment2.default)().to(time),
                        _react2.default.createElement('span', { className: messageDelivered })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'col-md-2 no-padding col-xs-2 imgContainer' },
                _react2.default.createElement('img', { src: profilePic, onError: function onError(e) {
                        return e.target.setAttribute("src", "http://www.cdn.innesvienna.net//Content/user-default.png");
                    }, className: 'profile-img img-responsive', alt: 'UserImage' })
            )
        );
    } else {
        return _react2.default.createElement(
            'div',
            { className: containerType },
            _react2.default.createElement(
                'div',
                { className: 'col-md-2 no-padding col-xs-2 imgContainer' },
                _react2.default.createElement('img', { src: profilePic, onError: function onError(e) {
                        return e.target.setAttribute("src", "http://www.cdn.innesvienna.net//Content/user-default.png");
                    }, className: 'profile-img img-responsive', alt: 'UserImage' })
            ),
            _react2.default.createElement(
                'div',
                { className: padding },
                _react2.default.createElement(
                    'div',
                    { className: messageType },
                    _react2.default.createElement(
                        'p',
                        { className: 'message' },
                        text
                    ),
                    _react2.default.createElement(
                        'time',
                        null,
                        received_Name,
                        ' \u2022 ',
                        (0, _moment2.default)().to(time)
                    )
                )
            )
        );
    }
};

exports.default = ChatMessage;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatmessage.js